// import gsap from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'
// import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class ClassPageLink {
  constructor() {
    this.smoothLinks;
    this.excute();
  }

  excutePageLink = (_target) => {
    gsap.to(window, {
      duration: 1,
      ease: "power4.inOut",
      delay: 0,
      scrollTo: {
        y: _target,
        autoKill: false,
        // offsetY: 0,
        // offsetY:() =>  getOffsetY(),
      },
      onComplete: () => {},
    });
  };

  excute = () => {
    const _this = this;
    this.smoothLinks = document.querySelectorAll(".js-smooth-link");
    // const getOffsetY = () => {
    //   const headerElem = document.querySelector('#js-header')
    //   return headerElem.offsetHeight * 0.4
    // }
    // if(location.hash){
    //   var anchor = document.querySelector( location.hash );
    //   gsap.to(window, {
    //     duration: 1,
    //     ease: 'power4.inOut',
    //     delay: 0.4,
    //     scrollTo: {
    //       y: anchor,
    //       autoKill: false,
    //       // offsetY: getOffsetY(),
    //       // offsetY:() =>  getOffsetY(),
    //     },
    //     onComplete: () => {},
    //   })
    // }
    this.smoothLinks.forEach((smoothLink) => {
      // 'click'.split(' ').forEach((eventName) => {
      // })
      smoothLink.addEventListener("click", (e) => {
        e.preventDefault();
        _this.excutePageLink(smoothLink.getAttribute("href"));
      });
    });
  };
}
